import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fetches the logged-in user's effective Watchlist + Portfolio caps and
// current usage counts. Re-fetches automatically whenever a `portfolio-changed`
// or `watchlist-changed` event fires on the window so the `5/10` indicators
// stay in sync after add/remove. Returns null while loading or for guests.
export function useUserLimits() {
  const { user } = useAuth();
  const [limits, setLimits] = useState(null);

  const refetch = useCallback(() => {
    if (!user) { setLimits(null); return; }
    axios.get(`${API}/me/limits`, { withCredentials: true })
      .then(r => setLimits(r.data || null))
      .catch(() => {});
  }, [user]);

  useEffect(() => { refetch(); }, [refetch]);

  useEffect(() => {
    const onChange = () => refetch();
    window.addEventListener('portfolio-changed', onChange);
    window.addEventListener('watchlist-changed', onChange);
    return () => {
      window.removeEventListener('portfolio-changed', onChange);
      window.removeEventListener('watchlist-changed', onChange);
    };
  }, [refetch]);

  return limits;
}
